

export function processFPUInput(currentValue, newValue){
    //Ensure precision is preserved when the user enters 0 as the final didget after the delimiter
    if(currentValue.slice(-1) === '0' && (currentValue.includes('.') || currentValue.includes(','))){
        let delimiter = currentValue.includes('.') ? '.' : ',';
        let precision = currentValue.split(delimiter)[1].length;
        return newValue.toFixed(precision);
    }

    return newValue;
}